export enum BurialSocietyFileType {
  ApplicationForm = 2,
  Constitution = 4,
  MerchantApplication = 5,
  ProofOfResidence = 1,
  Identification = 3,
  Photo = 6,
  ProofOfPayment = 7
}
